import gql from "graphql-tag";

export const CONTRIBUTOR_FEEDBACK_OKR_LIST = gql`
query contributors($okr_Goalstatement_Icontains:String,$employee: ID){
    contributors(okr_Goalstatement_Icontains:$okr_Goalstatement_Icontains,employee:$employee){
        edges{
          node{
            id
            okr{
              title
              id
              okrType
              isDiscarded {
                id
              }
            }
          }
        }
      }
}
`;
